import { render } from "./cards.vue?vue&type=template&id=10665f3c&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"

import "./cards.vue?vue&type=style&index=0&id=10665f3c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10665f3c"]])

export default __exports__